import request from "@/utils/request";

// 获取货架列表
export function getList(data) {
  return request.post("/wms/stand/queryPage", data);
}

export function edit(data) {
  return request.post(`/wms/stand/${data.id ? "updateById" : "insert"}`, data);
}

export function del(id) {
  return request.get("/wms/stand/deleteById/" + id);
}

export function findById(id) {
  return request.get("/wms/stand/findById/" + id);
}
